import { Directive, Inject, Input, HostListener } from 'ng-metadata/core';


@Directive({
	selector: '[prm-context-Menu]'
})


export class PrmContextMenu {
	 @Input() prmContextMenu: (event: MouseEvent | KeyboardEvent) => void;
	constructor(@Inject('$element') private $element: any,
	 			@Inject('$parse') private $parse: any,
	  			@Inject('$scope') private $scope: any) {}
	
	@HostListener('contextmenu', ['$event'])
	onContextMenu(event: MouseEvent | KeyboardEvent) {
		const parsedFunction = this.$parse(this.prmContextMenu);
		parsedFunction(this.$scope, {$event: event});
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/prmContextMenu.directive.ts